import { UPDATE_CALENDAR_SETTINGS } from "./actionTypes";

export default (macros, calendarSettings) => ({
  type: UPDATE_CALENDAR_SETTINGS,
  payload: {
    macros,
    calendarSettings
  },
});